import React, { useState, useCallback } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import Toast from "./components/Toast";

import Dashboard from "./pages/Dashboard";
import MyBookings from "./pages/MyBookings";
import History from "./pages/History";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";

import "./App.css";

function App() {
  const [selectedFlight, setSelectedFlight] = useState(null);
  const [passenger, setPassenger] = useState({ name: "", email: "", phone: "" });
  const [bookingConfirmed, setBookingConfirmed] = useState(false);
  const [toast, setToast] = useState(null);
  const [bookings, setBookings] = useState([]);

  const showToast = useCallback((message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3500);
  }, []);

  const handleSelectFlight = useCallback((flight) => {
    setSelectedFlight(flight);
    setBookingConfirmed(false);
    showToast(`${flight.airline} selected — complete your booking`, "info");
  }, [showToast]);

  const handleConfirmBooking = useCallback(() => {
    if (!passenger.name.trim()) {
      showToast("Please enter passenger name to confirm", "error");
      return;
    }
    const newBooking = {
      ...selectedFlight,
      passenger: { ...passenger },
      ref: `SKY${Math.random().toString(36).substring(2, 8).toUpperCase()}`,
      bookedAt: new Date().toISOString(),
      taxes: Math.round(selectedFlight.price * 0.18),
      total: selectedFlight.price + Math.round(selectedFlight.price * 0.18),
    };
    setBookings((prev) => [newBooking, ...prev]);
    setBookingConfirmed(true);
    showToast("Booking confirmed! Have a great flight ✈", "success");
  }, [passenger, selectedFlight, showToast]);

  const handleReset = useCallback(() => {
    setSelectedFlight(null);
    setPassenger({ name: "", email: "", phone: "" });
    setBookingConfirmed(false);
    showToast("Booking cleared", "info");
  }, [showToast]);

  return (
    <BrowserRouter>
      <div className="app-shell">
        <Sidebar />
        <div className="app-main">
          <Header passenger={passenger} selectedFlight={selectedFlight} />
          <main className="app-content">
            <Routes>
              <Route
                path="/"
                element={
                  <Dashboard
                    selectedFlight={selectedFlight}
                    passenger={passenger}
                    setPassenger={setPassenger}
                    bookingConfirmed={bookingConfirmed}
                    onSelectFlight={handleSelectFlight}
                    onConfirm={handleConfirmBooking}
                    onReset={handleReset}
                  />
                }
              />
              <Route path="/bookings" element={<MyBookings bookings={bookings} />} />
              <Route path="/history" element={<History bookings={bookings} />} />
              <Route path="/profile" element={<Profile passenger={passenger} bookings={bookings} />} />
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </main>
        </div>
        {toast && <Toast message={toast.message} type={toast.type} />}
      </div>
    </BrowserRouter>
  );
}

export default App;